import {
  SET_CHARGING_STATIONS,
  ADD_CHARGING_STATION,
  UPDATE_CHARGING_STATION,
  REMOVE_CHARGING_STATION,
  CLEAR_CHARGING_STATIONS,
} from 'actions';

const initialState = [];

export default (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case SET_CHARGING_STATIONS:
      return payload;
    case ADD_CHARGING_STATION:
      return [...state, payload];
    case UPDATE_CHARGING_STATION: {
      const { id, ...props } = payload;
      return state.map((s) => (s.id === id ? { ...s, ...props } : s));
    }
    case REMOVE_CHARGING_STATION:
      return state.filter((s) => s.id !== payload);
    case CLEAR_CHARGING_STATIONS:
      return initialState;
    default:
      return state;
  }
};
